module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Christine R. Regas started writing short playlets for Brownies to act, culminating in a full-length ‘Panto rhyme’ (i.e., pantomime in rhyme). Later, she was asked to write ")]), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Children’s Look In")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v(" for her church newspaper, which is where an early part of ")]), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("The Secret Sign")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v(" began. This continued for several years and three or four articles were also published in ")]), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Together with Children")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v(", a Christian resource magazine now out of print. She has also written articles for adults on the church paper and some sketches to be acted out in church.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6877f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0